import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { analyticsTrack } from '../../analyticsUtils';
import marketingImage1 from '../../../assets/images/human-Space-marketing.svg';
import arrowIcon from '../../../assets/images/icons/arrow-right.png';
import './MarketingMessages.scss';
var handleButtonClick = function handleButtonClick(projectId) {
  analyticsTrack('Clicked on Sales/Marketing Banner', {
    location: 'timesheet'
  });
  window.open("/featured?project_id=".concat(projectId), '_blank');
};
function MarketingMessages(_ref) {
  var aoes = _ref.aoes,
    projectId = _ref.projectId,
    position = _ref.position;
  return /*#__PURE__*/React.createElement("div", {
    className: "marketing-messages ".concat(position !== 'Top' && 'mb-3')
  }, /*#__PURE__*/React.createElement("div", {
    className: "marketing-messages__container"
  }, position !== 'Top' && /*#__PURE__*/React.createElement("img", {
    src: marketingImage1,
    alt: "Sales/Marketing",
    className: "marketing-messages__image"
  }), /*#__PURE__*/React.createElement("div", {
    className: "marketing-messages__content"
  }, position === 'Top' ? /*#__PURE__*/React.createElement("p", {
    className: "marketing-messages__text-light"
  }, "Need more ".concat(aoes[0] || 'Clinical Operations', " experts? See who is available"), position === 'Top' && /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return handleButtonClick(projectId);
    },
    className: "marketing-messages__btn"
  }, /*#__PURE__*/React.createElement("img", {
    alt: "Arrow",
    src: arrowIcon
  }))) : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("p", {
    className: "marketing-messages__text"
  }, "Need more ".concat(aoes[0] || 'Clinical Operations', " experts? We've got em.")), /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return handleButtonClick(projectId);
    },
    className: "marketing-messages__link"
  }, "Explore consultants with availability")))));
}
MarketingMessages.propTypes = {
  aoes: PropTypes.shape([]),
  position: PropTypes.string,
  projectId: PropTypes.string
};
MarketingMessages.defaultProps = {
  position: 'Top',
  aoes: [],
  projectId: ''
};
export default MarketingMessages;